var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dypolicy-container",
      class: {
        "ar-style":
          (_vm.lang === "ar" && _vm.activeCode === "ar") ||
          _vm.activeCode === "ar",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.lang,
              expression: "lang",
            },
          ],
          staticClass: "custom-nav-block",
          style: `paddingTop:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.handleBack },
            scopedSlots: _vm._u(
              [
                {
                  key: "left",
                  fn: function () {
                    return [
                      _c("img", {
                        staticClass: "left-nav",
                        style: {
                          tran: _vm.activeCode === "en" ? "0deg" : "180deg",
                        },
                        attrs: {
                          src: require("@/assets/packageAssets/common/arrow01.png"),
                          alt: "",
                        },
                      }),
                      _vm.packageName === "vava"
                        ? _c("img", {
                            staticClass: "left-icon vava",
                            staticStyle: { width: "93px" },
                            attrs: { src: require("./images/vava.png") },
                          })
                        : _vm._e(),
                      _vm.packageName === "joychat"
                        ? _c("img", {
                            staticClass: "left-icon joyChat",
                            staticStyle: { width: "118px" },
                            attrs: { src: require("./images/joyChat.png") },
                          })
                        : _vm._e(),
                      _vm.packageName === "echo"
                        ? _c("img", {
                            staticClass: "left-icon echo",
                            staticStyle: { width: "86px" },
                            attrs: { src: require("./images/echo.png") },
                          })
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                _vm.activeCode
                  ? {
                      key: "right",
                      fn: function () {
                        return [
                          _c("CStatus", {
                            staticClass: "lang-box",
                            attrs: {
                              arrowType: "deep",
                              statuslist: _vm.langList,
                              activeStatu: _vm.activeLang,
                            },
                            on: { selectStatus: _vm.handleLangChange },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading,
              expression: "!isLoading",
            },
          ],
          staticClass: "switch-tab right-read",
          style: `position: sticky; top: ${_vm.barHeight + 22}px; z-index: 99;`,
        },
        [
          _c(
            "div",
            {
              staticClass: "tab",
              class: { "active-tab": _vm.tabIndex == _vm.tabEnmu.host },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleSwitchTab(_vm.tabEnmu.host, true)
                },
              },
            },
            [_vm._v(_vm._s(_vm.hostPolicyDesc))]
          ),
          _c(
            "div",
            {
              staticClass: "tab",
              class: { "active-tab": _vm.tabIndex == _vm.tabEnmu.agency },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleSwitchTab(_vm.tabEnmu.agency, true)
                },
              },
            },
            [_vm._v(_vm._s(_vm.agentPolicyDesc))]
          ),
        ]
      ),
      _vm._l(_vm.currentPolicy, function (item) {
        return _c(
          "div",
          {
            staticClass: "policy-content-box",
            staticStyle: { "max-width": "1400px !important" },
          },
          [
            item.title
              ? _c("div", { staticClass: "policy-title right-read" }, [
                  _vm._v(_vm._s(item.title)),
                ])
              : _vm._e(),
            item.content
              ? _c("div", {
                  staticClass: "policy-text-box right-read",
                  domProps: { innerHTML: _vm._s(item.content) },
                })
              : _vm._e(),
          ]
        )
      }),
      _vm._m(0),
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false, closeOnClickOverlay: false },
          on: { close: _vm.close },
          model: {
            value: _vm.showDiaConfirm,
            callback: function ($$v) {
              _vm.showDiaConfirm = $$v
            },
            expression: "showDiaConfirm",
          },
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _vm.confirmTitle
              ? _c("div", { staticClass: "con" }, [
                  _vm._v(_vm._s(_vm.confirmTitle)),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "btn", on: { click: _vm.diaConfirmClose } },
              [_vm._v(_vm._s(_vm.$t("lang.gotit")))]
            ),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "policy-content-box",
        staticStyle: { visibility: "hidden", "margin-bottom": "0" },
      },
      [
        _c("div", {
          staticClass: "policy-text-box",
          attrs: { id: "target-box" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }